const DEFAULT_RETURN_PATH = '/';

/**
 * 로그인 뒤 돌아갈 곳 — 보호 라우트 가드가 `state.from` 으로 넘긴 앱 안 경로(새 견적 요청 알림 메일의 상세 링크 등).
 * 같은 출처의 경로(`/` 로 시작하고 `//` 가 아닌 것)만 받아 오픈 리다이렉트를 막고, 없거나 낯설면 첫 화면으로 보낸다.
 */
export const returnPathAfterSignIn = (locationState: unknown): string => {
  const from =
    typeof locationState === 'object' && locationState !== null && 'from' in locationState
      ? locationState.from
      : undefined;

  return typeof from === 'string' && from.startsWith('/') && !from.startsWith('//')
    ? from
    : DEFAULT_RETURN_PATH;
};
